function temData(valor) {
  if (!valor) return false;
  const texto = String(valor).trim();
  if (!texto || texto === '-') return false;

  if (texto.includes('/')) {
    const [dia, mes, ano] = texto.split(' ')[0].split('/');
    return !Number.isNaN(new Date(`${ano}-${mes}-${dia}T00:00:00`).getTime());
  }

  return !Number.isNaN(new Date(texto).getTime());
}

function normalizarSituacao(situacao) {
  return String(situacao || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();
}

function mapearEtapaPedido(situacaoErp, notas = []) {
  const situacao = normalizarSituacao(situacaoErp);
  if (situacao === 'cancelado') return 'Cancelado';
  if (!['faturado parcial', 'faturado total'].includes(situacao)) {
    return 'Em Separação';
  }

  // O status comercial não cria etapas logísticas. Sem NF sincronizada, não
  // há evidência para informar Nota Emitida ou Em Transporte.
  if (!notas.length) return 'Em Separação';
  const notasComSaida = notas.filter((nota) => temData(nota.notafiscaldtsaidaentrega));
  if (!notasComSaida.length) return 'Nota Emitida';

  const todasEntregues = notas.every((nota) => (
    temData(nota.notafiscaldtsaidaentrega)
    && temData(nota.notafiscaldtentregacliente)
  ));
  return todasEntregues ? 'Entregue' : 'Em Transporte';
}

module.exports = { mapearEtapaPedido, normalizarSituacao, temData };